import React from 'react';

export const COMPANY_NAME = 'HalalCred';
export const TAGLINE = 'Connecting Riba-Free Capital';